import React from 'react';
import { Box, Button } from '@mui/material';

export interface DrawerFooterProps {
  onReset: () => void;
  onApply: () => void;
  applyText?: string;
  resetText?: string;
  disabled?: boolean;
}

const DrawerFooter: React.FC<DrawerFooterProps> = ({
  onReset,
  onApply,
  applyText = 'APPLY',
  resetText = 'CLEAR FILTERS',
  disabled = false,
}) => {
  return (
    <Box sx={{
      px: 3,
      py: 1.5,
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 2
    }}>
      <Button
        variant="outlined"
        color="secondary"
        onClick={onReset}
        sx={{
          textTransform: 'uppercase',
          px: 4,
          py: 1.5,
          fontWeight: 600,
          color: '#39ACE7 !important',
          border: 'none !important',
          borderRadius: '8px !important'
        }}
      >
        {resetText}
      </Button>
      <Box sx={{ display: 'flex', gap: '8px' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onApply}
          disabled={disabled}
          sx={{
            textTransform: 'uppercase',
            px: '56px',
            py: 1.5,
            fontWeight: 600,
            color: '#ffffff !important',
            background: '#39ACE7 !important',
            borderRadius: '8px !important',
            '&.Mui-disabled': {
              color: '#ffffff !important',
              background: '#69c5f3ff !important',
            }
          }}
        >
          {applyText}
        </Button>
      </Box>
    </Box>
  );
};

export default DrawerFooter;
